/* globals APP_NAME */
import { getAnonymousID } from "redline-client-sdk";
import { keysPixel } from "../constants";

const startPixel = () => {
  const anonymousId = getAnonymousID()

    ! function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');

  fbq("init", keysPixel[APP_NAME], { external_id: anonymousId,})
  fbq('track', 'PageView');
}

export default startPixel
